<template>
  <section>
    <div
      id="grafica-autorizacion"
    class="box w-full h-full flex flex-wrap items-center justify-center"
    >
      <!-- <div v-show="loading" class="rounded-md icono-carga flex justify-center items-center">
        <LoadingIcon icon="puff" color="rgba(0,0,0,0.4)"/>
      </div> -->
      <div
      ref="elChart"
      style="height:450px; "
      class="w-full rounded-md"
      />
    </div>
  </section>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { apiAuthorizationReason } from '../../services'
import * as echarts from 'echarts'
import currency from 'currency.js'
import { useStore } from 'vuex'
export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {
    const store = useStore()
    const loading = ref(false)
    const elChart = ref(null)
    let chartInstance = reactive({})
    const isDark = computed(() => {
      return store.getters['main/darkMode']
    })
    const laData = ref([])
    const getData = () => {
      return laData.value.map(a => {
        return {
          value: a.porcentaje,
          name: a.Servicio,
          total: a.total,
          totalFormat: a.totalFormat
        }
      })
    }
    const setLaData = (values) => {
      laData.value = values
    }

    const initChart = () => {
      chartInstance = echarts.init(elChart.value, isDark.value ? 'dark' : 'light')
      const colorPalette = ['#04BF45', '#c31776', '#F29F05', '#12a0d7']
      const option = {
        // darkMode: true,
        backgroundColor: isDark.value ? '#313A55' : '',
        grid: {
          left: '8%',
          right: '0%',
          bottom: '2%',
          top: '18%',
          containLabel: true
        },
        title: {
          text: 'Consumo por Servicio',
          left: 15,
          top: 15,
          subtext: 'Valores en millones (M)'
        },
        toolbox: {
          top: 15,
          right: 15,
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          // trigger: 'item',
          formatter (a) {
            return `${a.name} <br> ${a.data.totalFormat} <br> ${a.percent}%`
          }
        },
        legend: {
          orient: 'vertical',
          left: 15,
          bottom: 15
        },
        // backgroundColor: 'blue',
        series: [
          {
            type: 'pie',
            radius: ['20%', '45%'],
            color: colorPalette,
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 9,
              borderColor: '#fff',
              borderWidth: 2
            },
            labelLine: {
              length: 4
            },
            label: {
              fontSize: 11,
              formatter (a) {
                  return `${a.data.name} \n ${currency(a.data.total / 1000000, { precision: 1, separator: '.' }).format()}M \n ${a.percent}%`
                }
            },
            data: []
          }
        ]
      }
      chartInstance.setOption(option)
      loadEvents()
    }
    const setChart = () => {
      const option = {
        series: [
          {
            data: getData()
          }
        ]
      }

      chartInstance.setOption(option)
    }
    const loadEvents = () => {
      window.addEventListener('resize', (evt) => {
        chartInstance.resize()
      })
    }

    /*
    * Hooks
    */
    watch(props.filters, (filter) => {
      if ([null, undefined, ''].includes(filter.client) ||
        [null, undefined, ''].includes(filter.year)
      ) return
      fetchResults(filter)
    })

    const fetchResults = (filter) => {
      loading.value = true
      apiAuthorizationReason(filter).then(({ data }) => {
        setLaData(data)
        setChart()
      }).catch((err) => {
        console.log(err.message)
      }).finally(() => {
        loading.value = false
      })
    }
    onMounted(() => {
      // console.log(111, context)
      initChart()
    })

    return {
      elChart,
      loading,
      getData
    }
  }
}
</script>

<style>
@media print {
  #grafica-autorizacion{
    overflow:hidden;
    width: 100%;
    /*page-break-before:always;*/
  }
}

</style>
